module.exports = __webpack_public_path__ + "static/img/logo-a.eb26ef98.png";